<template>
  <div class="main-app-bg legal-document">
    <div class="row wrapper wrapper-content">
      <div class="col-12">
        <router-link to="/">Back to Synergy Glass</router-link><br />
        <slot />
      </div>
    </div>
  </div>          
</template>

<style scoped>
.legal-document {
  min-height: 100vh;
  padding-left: 20px;
  padding-right: 20px;
}
</style>

<script>
export default {
  name: 'LegalLayout',
  components: {},
  data() {
    return {
      title: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>